<template>
  <div class="container">
    <div class="row cont-pad">
      <div class="col-12">
        <div>
          <h2>Our DDoS Solution</h2>
          <div class="solution-logo-wrap">
            <img class="solution-logo-nav" src="@/assets/img/logo-guard.png" />
            <img
              class="solution-logo-label"
              src="@/assets/img/logo-guard-text.png"
            />
          </div>
        </div>
      </div>
    </div>
    <div class="row cont-pad solution-points">
      <div class="col-lg-3 col-md-6" v-if="cat === 'gaming'">
        <img class="imgs" src="@/assets/img/ico-controller.png" />
        <h4>Built for Gaming</h4>
        <p>
          Give your players the premium gameplay experience only Cosmic Guard
          can offer.
        </p>
        <p>
          Our mitigation platform eliminates the lag and disconnects associated
          with DDoS Attacks to provide your players with a smooth and consistent
          experience.
        </p>
      </div>
      <div class="col-lg-3 col-md-6" v-if="cat === 'servers'">
        <img class="imgs" src="@/assets/img/ico-settings.png" />
        <h4>Built for Servers</h4>
        <p>
          Compatibility with any application TCP/UDP on Windows Server and
          Linux.
        </p>
        <p>
          Pay for only real user traffic with our Pay-As-You-Go pricing and our
          Unmetered Mitigation. Our portal provides full control and visibility
          of your service to give you peace of mind.
        </p>
      </div>
      <div class="col-lg-3 col-md-6" v-if="cat === 'hosts'">
        <img class="server-icon imgs" src="@/assets/img/server_img.png" />
        <h4>Built for Hosts</h4>
        <p>
          Partner with us to provide your customers our comprehensive DDoS
          Mitigation Security, led by a team of industry veterans.
        </p>
        <p>
          Reach out and inquire about our innovative, unmatched Pay-As-You-Go
          pricing for partners that makes us the perfect solution for hosts.
        </p>
      </div>
      <div class="col-lg-3 col-md-6" v-if="cat === 'enterprise'">
        <img class="imgs" src="@/assets/img/scale.png" />
        <h4>Built for Enterprise</h4>
        <p>
          Our platform is an agile solution that scales with the demands of your
          enterprise.
        </p>
        <p>
          Our engineers create and adapt specialized DDoS Solutions to fit the
          specific needs of our enterprise clients. Reach out and see what we
          can do to help your enterprise.
        </p>
      </div>
      <div class="col-lg-3 col-md-6">
        <img class="imgs" src="@/assets/img/blazing_connection.png" />
        <h4>Innovative DDoS Technology</h4>
        <p>
          Our in-house technology & proprietary algorithms allow us to filter
          traffic with confidence.
        </p>
        <p>Our platform guarantees:</p>
        <ul>
          <li>1-second mitigation time</li>
          <li>1-ms mitigation latency</li>
          <li>0 false positives</li>
          <li>Terabit-scale capacity</li>
        </ul>
      </div>
      <div class="col-lg-3 col-md-6">
        <img class="imgs" src="@/assets/img/robust_protection.png" />
        <h4>Premium Global Network</h4>
        <p>
          Blazing fast "no-throttle" network speeds with our Terabit-scale
          global capacity.
        </p>
        <p>
          Route your traffic through Cosmic Guard to take advantage of our
          premium network carefully optimized for worldwide low-latency,
          reliability, and security.
        </p>
      </div>
      <div class="col-lg-3 col-md-6">
        <img class="imgs" src="@/assets/img/ico-ticket.png" />
        <h4>24/7 Security Team</h4>
        <p>
          Direct access to the same team that architects and builds our
          mitigation platform.
        </p>
        <p>
          In high-stress situations, be confident that you'll be working with a
          team of industry veterans that can answer questions accurately and
          apply prompt solutions.
        </p>
      </div>
    </div>
    <div v-if="cat === 'servers' || cat === 'gaming'">
      <GetGuardian />
    </div>
  </div>
</template>

<script lang="js">
import GetGuardian from "@/components/products/reusable/GetGuardian.vue";

export default {
  components: {
    GetGuardian
  },
  name: "Solution",
  props: {
    home: {
      type: Boolean,
      default: false,
    },
    cat: {
      type: String,
      default: null,
    },
  },
  computed: {
    header: function() {
      return {};
    },
  },
};
</script>

<style scoped>
.circle-imgs {
  display: flex;
  margin: auto;
  justify-content: space-evenly;
  margin-top: 1.5em;
}
section {
  position: relative;
  --section-margin: 5em;
}
.img-circle {
  margin: auto;
  max-width: 400px;
  clip-path: circle(45% at center);
}
.middle-text {
  margin: auto;
}

.solution-logo-wrap {
  margin-bottom: 0.25em;
}
.solution-logo-nav {
  display: inline-block !important;
  height: 80px;
  padding: 6px 10px;
}
.solution-logo-label {
  display: inline-block !important;
  padding-left: 0 !important;
  margin-left: 0 !important;
  width: 19.5em;
  max-height: 78px;
}
.imgs {
  width: 6em;
  padding-bottom: 1em;
}
.solution-points p {
  font-size: 16px;
  text-align: left;
}
.solution-points ul {
  padding-left: 1em;
}
</style>
